import { PaymentAllocationType as PaymentAllocationTypeApi } from '@vendasta/billing';

export enum PaymentAllocationType {
  UNSET = 'UNSET',
  PURCHASE = 'PURCHASE',
  INVOICE = 'INVOICE',
}

export function paymentAllocationTypeFromApi(pApi: PaymentAllocationTypeApi): PaymentAllocationType {
  switch (pApi) {
    case PaymentAllocationTypeApi.PAYMENT_ALLOCATION_TYPE_INVOICE:
      return PaymentAllocationType.INVOICE;
    case PaymentAllocationTypeApi.PAYMENT_ALLOCATION_TYPE_PURCHASE:
      return PaymentAllocationType.PURCHASE;
    default:
      return PaymentAllocationType.UNSET;
  }
}
